module.exports = __webpack_public_path__ + "img/_stopped.f69b859b.svg";